import propTypes from 'prop-types';
import React from 'react';
import Styled from './link-style';

/**
 * The ETTX Link component. This component is used to redirect the user to another page.
 *
 * @param {object} props - The props object.
 * @param {string} props.to - The link to where the user will be redirected.
 * @param {React.ReactNode} props.children - The children of the component.
 * @returns {JSX.Element} The Link component
 */
const Link = ({ to, children }) => (
  <Styled.Link to={to}>{children}</Styled.Link>
);

Link.propTypes = {
  /** The link to where the user will be redirected. */
  to: propTypes.string.isRequired,
  /** The children of the component. */
  children: propTypes.node,
};

Link.defaultProps = {
  children: 'Go to ...',
};

export default Link;
